import React, { memo } from 'react';
import PropTypes from '../../types';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { GenericDivider } from 'web-ui-components/lib/layout/content';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { Content } from '../../infrastructure/content';
import RequiredSignatories from './components/RequiredSignatories';
import AuthorisedSignatories from './components/AuthorisedSignatories';
import ApplicableToAccounts from './components/ApplicableToAccounts';

const BusinessMandateGroup = memo(function BusinessMandateGroup({ values }) {
  return (
    <Content>
      {({
        businessMandatePageTitle = '',
        businessMandateContentA,
        businessMandateContentB,
        businessMandatePageTitle2,
        businessMandateContentC
      }) => (
        <div>
          <PageHeading>{businessMandatePageTitle}</PageHeading>
          <StandardBody>
            <p>{businessMandateContentA}</p>
            <p>{businessMandateContentB}</p>
          </StandardBody>
          <RequiredSignatories values={values} />
          <GenericDivider />
          <PageHeading>{businessMandatePageTitle2}</PageHeading>
          <StandardBody>
            <p>{businessMandateContentC}</p>
          </StandardBody>
          <ApplicableToAccounts values={values} />
          {values && values.future_accounts === 'Y' && (
            <ConditionalPanel isVisible>
              <AuthorisedSignatories values={values} />
            </ConditionalPanel>
          )}
        </div>
      )}
    </Content>
  );
});

BusinessMandateGroup.propTypes = {
  values: PropTypes.shape({})
};

export default BusinessMandateGroup;
